import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "@builder/components/editable/EditableInfo";
import { EditableProps } from "@builder/components/editable/editableProps";
import OliverText from "@builder/components/general/OliverText";
import TextInput from "@builder/components/general/TextInput";
import Toggle from "@builder/components/general/Toggle";
import EditIcon from "../../EditIcon";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { SimpleCartNode } from "@common/build/types";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";

const EditCartLineItems = ({ parent }: EditableProps) => {
    const simpleCartNode = useAppSelector(getSelectedNode) as SimpleCartNode | undefined;
    const dispatch = useAppDispatch();

    return (
        <SidebarCollapse title="Line items" parent={parent}>
            <EditableInfo
                header="Built-in actions"
                body="Click on any line item to edit it during checkout."
                body2="When any product, custom sale, or order note is selected from the cart, the appropriate dialog box will open to edit that item."
            />
            <Toggle
                checked={simpleCartNode?.expandedNode.showItemUnit || false}
                callback={(checked: boolean) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showItemUnit"], value: checked }));
                }}
                label="Show item unit"
            />
            <TextInput
                placeholder="unit"
                value={simpleCartNode?.expandedNode.showItemUnitLabel || ""}
                callback={(value: string) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showItemUnitLabel"], value }));
                }}
            />

            <Toggle
                label="Show variation details"
                checked={simpleCartNode?.expandedNode.showVariationDetails || false}
                callback={(checked: boolean) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showVariationDetails"], value: checked }));
                }}
            />

            <Toggle
                label="Show SKU"
                checked={simpleCartNode?.expandedNode.showSku || false}
                callback={(checked: boolean) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showSku"], value: checked }));
                }}
            />
            <TextInput
                placeholder="sku"
                value={simpleCartNode?.expandedNode.showSkuLabel || ""}
                callback={(value: string) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showSkuLabel"], value }));
                }}
            />

            <Toggle
                label="Show discounts and fees"
                checked={simpleCartNode?.expandedNode.showDiscountAndFees || false}
                callback={(checked: boolean) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showDiscountAndFees"], value: checked }));
                }}
            />
            <OliverText text="Product discount and fee labels can be edited via the Actions menu or during checkout." size="xxs" />

            <Toggle
                label="Show product notes"
                checked={simpleCartNode?.expandedNode.showNote || false}
                callback={(checked: boolean) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showNote"], value: checked }));
                }}
            />
            <OliverText text="Product notes will be shown under the product it relates to." size="xxs" />

            <Toggle
                label="Show delete line item icon"
                checked={simpleCartNode?.expandedNode.showDeleteIcon || false}
                callback={(checked: boolean) => {
                    dispatch(updateNodeProperty({ propertyPath: ["expandedNode", "showDeleteIcon"], value: checked }));
                }}
            />
            <EditIcon customLabel="Delete line item icon" noWrapper path={["expandedNode", "deleteItemIcon"]} />
        </SidebarCollapse>
    );
};

export default EditCartLineItems;
